import type { Lyric, LyricSeo } from '@lyricstream/shared';
import { SeoData } from './seo.service';

/**
 * Données SEO d'un chant. Canonique unique en `/fr/lyric/<slug>` : `/fr|/ht|/en|/es` ne traduisent que
 * l'interface, le texte du chant a sa propre langue (même règle que le sitemap, cf. src/seo.ts) —
 * donc pas de hreflang sur un chant. `lang` ne sert qu'à `og:locale`.
 */
/** Champs communs au détail (`Lyric`) et au résumé SEO (`LyricSeo`). */
type LyricSeoSource = Pick<Lyric, 'id' | 'slug' | 'title' | 'displayTitle' | 'seoDescription'> & Partial<Pick<Lyric, 'coverImage' | 'coverImageUrl'>>;

export function buildLyricSeo(lyric: LyricSeoSource | LyricSeo, lang: string): SeoData {
  return {
    title: `${lyric.displayTitle || lyric.title} — LyricStream`,
    description: lyric.seoDescription || `Paroles de ${lyric.title}`,
    path: `/fr/lyric/${encodeURIComponent(lyric.slug || lyric.id)}`,
    image: lyric.coverImage || ('coverImageUrl' in lyric ? lyric.coverImageUrl : undefined),
    type: 'music.song',
    lang,
  };
}
